module.exports = __webpack_public_path__ + "static/img/dcb1f8b6ff1223c87be4a11a6b3a5340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_xinyun.png
// module id = JOmE
// module chunks = 1